import styled from '@emotion/styled';

export const PlaybooksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 12px 24px 8px;
`;

export const CardContainer = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  background: ${({ disabled }) => (disabled ? '#f7f7f8' : '#ffffff')};
  opacity: ${({ disabled }) => (disabled ? 0.6 : 1)};
`;

export const CardHeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const CardName = styled.h4`
  margin: 0;
  font-size: 13px;
  font-weight: 700;
  color: #1e1e1e;
`;

export const CardDescription = styled.p`
  margin: 0;
  font-size: 12px;
  color: #6e6e71;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const BadgesRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

const RISK_COLORS: Record<string, { bg: string; color: string }> = {
  low: { bg: '#e6f7ec', color: '#1a7f37' },
  medium: { bg: '#fff4e0', color: '#9a6300' },
  high: { bg: '#fde8e8', color: '#c22b2b' },
};

export const RiskBadge = styled.span<{ risk: string }>`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  text-transform: capitalize;
  background: ${({ risk }) => RISK_COLORS[risk]?.bg ?? '#eeeeee'};
  color: ${({ risk }) => RISK_COLORS[risk]?.color ?? '#6e6e71'};
`;

export const MetricBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  background: #eef4ff;
  color: #0073ff;
`;

export const CardFooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 4px;
`;

export const DataFieldsLink = styled.a`
  font-size: 12px;
  color: #0073ff;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const CardError = styled.div`
  font-size: 12px;
  color: #c22b2b;
`;
